<template>
  <div class="order-modal">
    <div class="order-modal-content">
      <h2 class="order-modal-title">Your order “{{ tariffList[tariff] }}”</h2>
      <div class="order-modal-steps">
        <hr class="order-modal-steps-line" />
        <div class="order-modal-steps-container">
          <div class="order-modal-steps-item">
            <div class="order-modal-steps-item-circle ready" :class="steps[1] ? 'active' : ''">
              {{ isStepReady(1) ? '' : 1 }}
              <img v-if="isStepReady(1)" src="@/assets/img/checked-icon.svg" alt="checked" />
            </div>
            <p class="order-modal-steps-item-name">Property selection</p>
          </div>
          <div class="order-modal-steps-item">
            <div class="order-modal-steps-item-circle" :class="steps[2] ? 'active' : ''">
              {{ isStepReady(2) ? '' : 2 }}
              <img v-if="isStepReady(2)" src="@/assets/img/checked-icon.svg" alt="checked" />
            </div>
            <p class="order-modal-steps-item-name">AI <br />set-up</p>
          </div>
          <div class="order-modal-steps-item">
            <div class="order-modal-steps-item-circle" :class="steps[3] ? 'active' : ''">
              {{ isStepReady(3) ? '' : 3 }}
              <img v-if="isStepReady(3)" src="@/assets/img/checked-icon.svg" alt="checked" />
            </div>
            <p class="order-modal-steps-item-name">File uploading</p>
          </div>
          <div class="order-modal-steps-item">
            <div class="order-modal-steps-item-circle" :class="steps[4] ? 'active' : ''">
              {{ isStepReady(4) ? '' : 4 }}
              <img v-if="isStepReady(4)" src="@/assets/img/checked-icon.svg" alt="checked" />
            </div>
            <p class="order-modal-steps-item-name">Order summary</p>
          </div>
          <div class="order-modal-steps-item">
            <div class="order-modal-steps-item-circle" :class="steps[5] ? 'active' : ''">5</div>
            <p class="order-modal-steps-item-name">Payment</p>
          </div>
        </div>
      </div>
      <PropertySelection v-if="steps[1]" :save-type-and-floors="saveTypeAndFloors" :defaults="{ floorsCount, type }" :tariff="tariff" :open-next-step="openNextStep" />
      <StyleSelection v-if="steps[2]" :tariff="tariff" :defaults="{ style, view }" :save-style-and-view="saveStyleAndView" :open-prev-step="openPrevStep" :open-next-step="openNextStep" />
      <PlansUploading v-if="steps[3]" :defaults="{ plans, logo, link, comment }" :tariff="tariff" :save="savePlansAndBrand" :open-prev-step="openPrevStep" :open-next-step="openNextStep" />
      <OrderSummary
        v-if="steps[4]"
        :defaults="{ promocode, email, customerType, style, view }"
        :change-promocode="changePromocode"
        :change-email-and-type="changeEmailAndType"
        :calculated-price="calculatedPrice"
        :tariff="tariff"
        :open-prev-step="openPrevStep"
        :make-order="makeOrder"
        :errors="errors"/>
      <Payment v-if="steps[5]" :link="paymentLink" />
    </div>
    <img @click="() => closeOrderModal()" class="order-modal-close" src="@/assets/img/X_close.svg" alt="close-icon" />
  </div>
</template>

<script>
import PropertySelection from '@/Components/En/Order/Steps/PropertySelection.vue';
import StyleSelection from '@/Components/En/Order/Steps/StyleSelection.vue';
import PlansUploading from '@/Components/En/Order/Steps/PlansUploading.vue';
import OrderSummary from '@/Components/En/Order/Steps/OrderSummary.vue';
import Payment from '@/Components/En/Order/Steps/Payment.vue';
import { api } from '@/api';
import { PAGE_TEMPLATE } from '@/enums/pageTemplate';

export default {
  name: 'OrderSteps',
  components: {
    PropertySelection,
    StyleSelection,
    PlansUploading,
    OrderSummary,
    Payment,
  },
  props: {
    tariff: {
      default: 1,
      type: Number,
    },
    closeOrderModal: {
      default: () => null,
      type: Function,
    },
  },
  data: () => ({
    style: 'scandy',
    view: 'city',
    windowType: 'standard',
    type: 'apartment',
    floorsCount: 1,
    plans: [],
    logo: null,
    link: null,
    comment: null,
    email: null,
    customerType: 'company',
    promocode: null,
    steps: {
      1: true,
      2: false,
      3: false,
      4: false,
      5: false,
    },
    calculatedPrice: {
      count: 0,
      items: {},
      sum: 0,
    },
    allowedViews: {
      city: 'city',
      village: 'village',
      sandy: 'sandy shore',
      garden: 'garden',
      pool: 'pool',
    },
    paymentLink: null,
    tariffList: {
      1: 'Basic set',
      2: 'Plus set',
      3: 'Pro set',
      4: 'Render set',
      6: 'Max set',
    },
    errors: {
      errorMessagePromo: null,
      errorMessage: null,
    },
  }),
  methods: {
    openNextStep() {
      const currentIndex = Object.values(this.steps).findIndex((v) => v === true) + 1;
      this.steps[currentIndex] = false;
      this.steps[currentIndex + 1] = true;
    },
    openPrevStep() {
      const currentIndex = Object.values(this.steps).findIndex((v) => v === true) + 1;
      this.steps[currentIndex] = false;
      this.steps[currentIndex - 1] = true;
    },
    isStepReady(step) {
      const currentIndex = Object.values(this.steps).findIndex((v) => v === true) + 1;
      return currentIndex > step;
    },
    changePromocode(promocode) {
      this.promocode = promocode;
      this.calculatePrice();
    },
    changeEmailAndType(email, type) {
      this.email = email;
      this.customerType = type;
    },
    async calculatePrice() {
      const params = {
        count: this.floorsCount,
        tariff_id: this.tariff,
      };
      if (this.promocode) {
        params.promocode = this.promocode;
      }
      await api.getCalculatedPriceEn(params).then(({ data }) => {
        this.calculatedPrice = {
          ...data,
          count: this.floorsCount,
        };
        console.log(this.calculatedPrice);
      });
    },
    async makeOrder(e) {
      e.stopPropagation();
      e.preventDefault();
      this.errors.errorMessagePromo = null;
      this.errors.errorMessage = null;

      const fd = new FormData();

      if (!this.email) {
        return;
      }

      fd.append('email', this.email);
      fd.append('customer_type', this.customerType);
      fd.append('style', this.style);
      fd.append('tariff_id', this.tariff);
      fd.append('comment', this.comment);
      fd.append('property_type', this.type);
      fd.append('plans_count', this.floorsCount);
      fd.append('window_type', this.windowType);

      this.plans.forEach((plan) => fd.append('plans[]', plan));

      if (this.promocode) {
        fd.append('promocode', this.promocode);
      }

      if (this.tariff !== 1) {
        fd.append('environment_type', this.allowedViews[this.view]);
      }

      if (this.tariff === 3 || this.tariff === 6) {
        fd.append('widget_branding_logo', this.logo);
        fd.append('widget_branding_url', this.link);
      }

      await api
        .createOrderModal(fd)
        .then(({ data }) => {
          this.paymentLink = `${data.data.payment_link}&${PAGE_TEMPLATE}&exfo=742`;
          this.openNextStep();
        })
        .catch((err) => {
          const { message } = err.response.data;

          if (message.includes('Invalid code') || message.includes('Already used')) {
            this.errors.errorMessagePromo = message;
          } else {
            this.errors.errorMessage = message;
          }
        })
        .finally(() => {});
    },
    saveStyleAndView(style, view, windowType) {
      this.style = style;
      this.view = view;
      this.windowType = windowType;
    },
    saveTypeAndFloors(type, floorsCount) {
      this.type = type;
      this.floorsCount = floorsCount;
    },
    async savePlansAndBrand(plans, comment, logo, link) {
      this.plans = plans;
      this.comment = comment;
      this.logo = logo;
      this.link = link;
      await this.calculatePrice();
    },
    saveEmailAndType(email, type) {
      this.email = email;
      this.customerType = type;
    },
  },
};
</script>
